import React from 'react';
import {designSystemToken} from '@lightricks/react-design-system';
import styles from './AssetsProgressMeter.module.scss';

interface AssetsProgressMeterProps {
  acceptedCount: number;
  pendingCount: number;
  editsRequestedCount: number;
  notSubmittedCount: number;
}

function segmentColors() {
  return {
    accepted: designSystemToken('semantic.bg.success'),
    pending: designSystemToken('semantic.bg.warning'),
    editsRequested: designSystemToken('reference.gray.400'),
  };
}

function AssetsProgressMeter({
  acceptedCount,
  pendingCount,
  editsRequestedCount,
  notSubmittedCount,
}: AssetsProgressMeterProps) {
  const colors = segmentColors();
  const segments = [
    {key: 'accepted', count: acceptedCount, color: colors.accepted},
    {key: 'pending', count: pendingCount, color: colors.pending},
    {
      key: 'editsRequested',
      count: editsRequestedCount,
      color: colors.editsRequested,
    },
  ].filter((segment) => segment.count > 0);

  return (
    <div className={styles.meter} data-testid="assets-progress-meter">
      {segments.map((segment) => (
        <div
          key={segment.key}
          data-testid={`assets-meter-segment-${segment.key}`}
          className={styles.segment}
          style={{flexGrow: segment.count, backgroundColor: segment.color}}
        />
      ))}
      {notSubmittedCount > 0 ? (
        <div
          data-testid="assets-meter-segment-remaining"
          className={styles.remaining}
          style={{flexGrow: notSubmittedCount}}
        />
      ) : null}
    </div>
  );
}

export default React.memo(AssetsProgressMeter);
